/**
 * Layout Module
 * Core layout components and configuration
 */

import type { RouteObject } from 'react-router-dom';
import type { Module } from '../../index';

const layoutModule: Module = {
  name: 'layout',
  path: '/layout',
  routes: [] // Layout is used as a wrapper, not a route
};

export default layoutModule;

